import { com } from '@roai/protobuf';
import { IDeviceInfo } from '../info/types';
import { gzipSync } from 'fflate';
// import { decodeDeviceInfo } from '../info/decode';
import { ICommonInfo } from '../info/common';

export const encodeBody = async (
  obj: {
    deviceInfo: IDeviceInfo;
    params: {
      [key: string]: string;
    };
    preRequestId: Nullable<string>;
    requestId: string;
    eventData: {
      eventId: string;
      preEventId: string;
      eventType: string;
      [key: string]: string;
    };
    commonInfo: ICommonInfo;
  }
): Promise<Uint8Array | string> => {

  const { deviceInfo, params, requestId, preRequestId, eventData, commonInfo } = obj;
  const { preEventId, eventId, eventType, ...rest } = eventData;

  const events = com.ssp.sdk.event.EventData.create({
    eventId,
    preEventId,
    eventName: eventType,
    timestamp: Date.now(),
    eventType,
    eventParams: {
      ...params,
      ...rest,
    },
    attribution: {},
  });

  const baseEventData = com.ssp.sdk.event.BaseEventData.create({
    sessionId: commonInfo.sessionId,
    preSessionId: commonInfo.preSessionId,
    requestId: requestId,
    preRequestId: preRequestId,
    timestamp: Date.now(),
    appId: commonInfo.appId,
    appVersion: commonInfo.appVersion,
    sdkVersion: commonInfo.sdkVersion,
    bizType: commonInfo.bizType,
    platform: commonInfo.platform,
    dataVersion: commonInfo.dataVersion,
    events: [events],
    deviceId: commonInfo.deviceId,
  });

  // console.log('deviceInfo', decodeDeviceInfo(deviceInfo));
  const info = com.tecdo.sdk.web.DeviceInfo.create(deviceInfo);

  const webEventData = com.tecdo.sdk.web.WebEventData.create({
    baseData: baseEventData,
    deviceInfo: info,
  });

  console.log('webEventData', webEventData);

  const request = com.tecdo.sdk.common.SdkEventRequest.create({
    platform: commonInfo.platform,
    dataVersion: commonInfo.dataVersion,
    deviceId: commonInfo.deviceId,
    webData: webEventData,
  });
  const encodeReq = com.tecdo.sdk.common.SdkEventRequest.encode(request).finish();
  return gzipSync(encodeReq);
}

export type EventData = com.ssp.sdk.event.IEventData;
